
import { mapState } from 'vuex'
import LayoutMixin from '@/mixins/layout'
import FaqList from './components/-faq-list'
import FaqListMo from './components/faq-list-mo'
import SupportTop from '@/components/page/support-top.vue'
export default {
  components: {
    FaqList,
    SupportTop,
    FaqListMo,
  },
  mixins: [LayoutMixin],
  async asyncData(content) {
    const { app } = content
    try {
      const res = await app.$API.support.getFrequentlyAskedQuestions({
        type: '1',
        size: 15,
        current: 1,
      })
      const tabs = await app.$API.support.getFrequentlyAskedQuestionsTab() || []
      const { current, records: list = [], total } = res
      list.forEach((item) => {
        item.folded = true
      })
      return {
        tabs,
        pagination: { current, total, size: 15 },
        individualQuestion: list,
      }
    } catch (e) {
      return {
        tabs: [],
        individualQuestion: [],
      }
    }
  },
  data() {
    return {
      type: '1',
      folded: true,
      params: {
        size: 15,
        current: 1,
      },
      pagination: {
        current: 1,
        total: 0,
        size: 15,
      },
      individualQuestion: [],
      nowIndex: 0,
      tabMobileList: [
        {
          id: '1',
          title: this.$t('serviceSupport.commst_problems.personal'),
          faqTitle: this.$t('serviceSupport.commst_problems.FAQs'),
        },
        {
          id: '2',
          title:
            this.$t('modules.logisticsService.productList.onlineRetailers') +
            '&' +
            this.$t('serviceSupport.commst_problems.enterprise'),
          faqTitle: this.$t('serviceSupport.commst_problems.corporate'),
        },
        {
          id: '3',
          title: this.$t('serviceSupport.commst_problems.other'),
          faqTitle: this.$t('serviceSupport.commst_problems.frequently'),
        },
      ],
    }
  },
  head() {
    return {
      title: this.$t(`navs.FAQ`) + this.$t('navs.suffixName'),
    }
  },
  computed: {
    ...mapState({
      resizeInfo: (state) => state.resizeInfo,
    }),
  },
  methods: {
    handChange(e) {
      const params = {
        type: e,
        ...this.params,
      }
      this.type = e
      this.getData(params)
    },
    tabMobileClick(id, index) {
      const type = id + ''
      const params = {
        type: type,
        ...this.params
      }
      this.type = type
      this.nowIndex = index
      this.getData(params)
    },
    changeFolded(value) {
      this.folded = value
    },
    async getData(params) {
      try {
        const res = await this.$API.support.getFrequentlyAskedQuestions(params)
        const { current, records: list = [], total } = res
        this.pagination = {
          current,
          total,
          size: params.size,
        }
        list.forEach((item) => {
          item.folded = this.folded
        })
        this.individualQuestion = list
      } catch (err) {}
    },
    change(current) {
      const params = { ...this.params, current, type: this.type }
      this.getData(params)
    },
  },
}
